import { IContextualValue } from 'common/schema/contextual-value/ContextualValue';
import { create, all } from 'mathjs';
import moment, { Moment } from 'moment';
import { IMetadata } from '../Metadata';
import { MetadataType } from '../MetadataType';

export const ComputeMath = create(all);

const UntypedComputeMath = ComputeMath as any;

UntypedComputeMath.typed.addType({
  name: 'Moment',
  test: function (x: any) {
    return moment.isMoment(x);
  }
});

/**
 * Funzioni matematiche custom, ad esempio per lavorare sugli intervalli di date
 */
ComputeMath.import({
  /**
   * Calcola la differenza in anni tra due date
   */
  date_diff_anni: ComputeMath.typed('date_diff_anni', {
    'Moment, Moment': function (a: Moment, b: Moment) {
      return b.diff(a, 'years');
    }
  }),
  /**
   * Calcola la differenza in mesi tra due date
   */
  date_diff_mesi: ComputeMath.typed('date_diff_mesi', {
    'Moment, Moment': function (a: Moment, b: Moment) {
      return b.diff(a, 'months');
    }
  }),
  /**
   * Calcola la differenza in giorni tra due date
   */
  date_diff_giorni: ComputeMath.typed('date_diff_giorni', {
    'Moment, Moment': function (a: Moment, b: Moment) {
      return b.diff(a, 'days');
    }
  })
});

export const ComputeMathUtils = {
  prepareMetadataValue(value: any, metadata: IMetadata) {
    if (metadata.datatype === MetadataType.Date) {
      return moment(value);
    }
    return value ?? 0;
  },
  prepareContextualValue(value: any, contextual: IContextualValue<any>) {
    if (contextual.datatype === MetadataType.Date) {
      return moment(value, [
        moment.ISO_8601,
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'YYYY-MM-DD'
      ]);
    }
    return value ?? 0;
  }
};
